(function () {
    function adjustLayout(element) {
        var container = element.parentNode;
        var containerWidth = container.clientWidth;
        var input = container.getElementsByClassName('FormCaptcha__Input')[0];
        var button = container.getElementsByClassName('Form__Element__Button')[0];
        var image = container.getElementsByClassName('FormCaptcha__Image')[0];
        var span = container.getElementsByClassName('Form__Element__Span')[0];
        if (button) {
            button.style.height = '40px';
            button.style.marginTop = 0;
            button.style.marginBottom = '10px';
            button.style.marginTop = 0;
            button.style.verticalAlign = 'top';
        }

        if (input) {
            input.style.height = '40px';
            input.style.border = 'none';
            input.style.marginBottom = '10px';
            input.style.marginTop = 0;
            input.style.verticalAlign = 'top';
        }

        if (image) {
            image.style.height = '40px';
            image.style.verticalAlign = 'middle';
            image.style.marginBottom = '10px';
            image.style.marginTop = 0;
            image.style.verticalAlign = 'top';
        }
        
        if ("contact-us__section" === container.className) {
            if (input) {
                input.style.border = '1px solid #e5e5e5';
                input.style.width = '100%';
            }

            if (button) {
                button.style.width = '100%';
            }

            if (span) {
                span.style.width = '100%';
                span.style.paddingLeft = 0;
            }
            //image.style.maxWidth = '100%';
            //image.style.width = '100%';
            
            
            
        } else {
            if (input) {
                input.style.border = '1px solid #e5e5e5';
            }
            
            if (containerWidth < 500) {
                //image.style.maxWidth = '100%';
                //image.style.width = '100%';
                if (input) {
                    input.style.width = '100%';
                }

                if (button) {
                    button.style.width = '100%';
                }

                if (span) {
                    span.style.width = '100%';
                }
                
            } else {
                //image.style.maxWidth = '32%';
                //image.style.width = '32%';
                if (input) {
                    input.style.width = '32%';
                }
                if (button) {
                    button.style.width = '32%';
                }
                if (span) {
                    span.style.width = '100%';
                }
            }

            if (span) {
                span.style.paddingLeft = 0;
            }
        }
    }

    js.adjustLayout = (function () {
        function initialize() {
            var containers = document.getElementsByClassName("Form__MainBody");
            for (var i = 0; i < containers.length; i++) {
                adjustLayout(containers[i]);
            }
            
            window.onresize = function () {
                var containers = document.getElementsByClassName("Form__MainBody");
                for (var i = 0; i < containers.length; i++) {
                    adjustLayout(containers[i]);
                }
            };
        }
        return {
            initialize: initialize
        }
    })();
})();
